import { useEffect, useState } from "react";
import { Search, Star } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { PortionForm } from "@/components/nutri/PortionForm";

export const SearchTab = ({ meal, date, onDone }) => {
  const [q, setQ] = useState("");
  const [res, setRes] = useState({ custom: [], foods: [] });
  const [picked, setPicked] = useState(null);

  useEffect(() => {
    const t = setTimeout(() => {
      api.get("/nutri/foods/search", { params: { q } })
        .then((r) => setRes({ custom: r.data?.custom ?? [], foods: r.data?.foods ?? [] }))
        .catch(() => setRes({ custom: [], foods: [] }));
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  if (picked) return <PortionForm food={picked} meal={meal} date={date} source={picked.id ? "custom" : "db"} onDone={onDone} onBack={() => setPicked(null)} />;

  const all = [...res.custom.map((f) => ({ ...f, custom: true })), ...res.foods];
  return (
    <div className="space-y-3 pt-4">
      <div className="relative">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#a3b1aa]" />
        <Input data-testid="food-search-input" autoFocus placeholder="es. riso, pollo, yogurt…" value={q} onChange={(e) => setQ(e.target.value)} className="h-12 pl-9" />
      </div>
      <div className="max-h-72 divide-y divide-white/5 overflow-y-auto" data-testid="food-search-results">
        {all.length === 0 && <p className="py-6 text-center text-sm text-[#a3b1aa]">Nessun alimento trovato. Crealo nella scheda "Personalizzato".</p>}
        {all.map((f, i) => (
          <button key={f.id || f.name} data-testid={`food-result-${i}`} onClick={() => setPicked(f)}
            className="flex w-full items-center justify-between gap-3 py-3 text-left hover:text-[#c4dcca]">
            <span className="flex items-center gap-2 text-sm">{f.custom && <Star size={12} className="text-[#98bfa2]" />}{f.name}</span>
            <span className="shrink-0 font-mono text-xs text-[#a3b1aa]">{Math.round(f.kcal)} kcal/100g</span>
          </button>
        ))}
      </div>
    </div>
  );
};
